import { Box, Typography } from '@mui/material'
import { useTranslate } from 'ra-core'

import PressureChart from '../../components/PressureChart'
import { VEHICLE_TYPES_ICONS } from '../../config/vehicles'
import { TOTAL_KEY, USED_KEY } from '../../utils/pressureGraph'

const getCurrentPoint = (points, now) => points.findLast((point) => point.timestamp <= now) ?? points[0]

const VehicleTypeUtilisation = ({ vehicleType, points, now }) => {
  const translate = useTranslate()
  const { type: Icon } = VEHICLE_TYPES_ICONS[vehicleType]
  const current = getCurrentPoint(points, now)
  const used = current[USED_KEY] ?? 0
  const total = current[TOTAL_KEY] ?? 0
  const rate = total ? Math.round((used / total) * 100) : 0

  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 2 }}>
      <Box display="flex" alignItems="center" gap={1}>
        <Icon fontSize="small" />
        <Typography variant="subtitle1" fontWeight="bold">
          {translate(`resources.vehicles.enums.type.values.${vehicleType.toLowerCase()}`)}
        </Typography>
      </Box>
      <Box display="flex" alignItems="baseline" gap={1} mb={1}>
        <Typography variant="h4">{rate}%</Typography>
        <Typography variant="body2" color="text.secondary">
          {translate('mymove.statistics.utilisation.inUseNow', { used, total })}
        </Typography>
      </Box>
      <PressureChart points={points} height={180} compact />
    </Box>
  )
}

export default VehicleTypeUtilisation
